
















import { Vue, Component, Prop } from 'vue-property-decorator'
import VueI18n from 'vue-i18n'

@Component({})
export default class AppAppsDrawer extends Vue {
  @Prop() readonly i18n!: VueI18n

  onClose () {
    this.$emit('close')
  }
}
